// 3rd Party
import React from 'react';

// Components
import { colors } from 'common/styles/style-constants';
import { H1, P } from 'common/styles/oc-styled-components';

import SatisfactionGuaranteeSvg from '../../../common/components/svgs/SatisfactionGuaranteeSvg';

import { Container, Wrapper } from './styled-components';

// Component
const Guarantee = () => (
  <Wrapper padding="20px 25px" width="100%">
    <Container height="115px" margin="0 30px 0 auto">
      <SatisfactionGuaranteeSvg />
    </Container>
    <Container height="115px">
      <H1 color={colors.darkBlue} fontSize="24px" margin="0 0 10px 0">
        The Opencare Smile Guarantee
      </H1>
      <P color={colors.darkBlue}>
        We only work with the top rated 10% of dentists. If your new Opencare
        dentist doesn't live up to your expectations, we'll cover your co-pay up
        to $100.
      </P>
    </Container>
  </Wrapper>
);

export default Guarantee;
